import React from "react";
import { connect } from "react-redux";
import { Col, Row } from "react-bootstrap";
// import { Row, Col } from "antd";
import useWindowSize from "../../utils/useWindowSize";
import Logout from "../../containers/Pages/Login/Logout";
import ChangePassword from "../../containers/Pages/Login/ChangePassword";
import PayoutDasboardComponent from "./PayoutDashboardComponent"

const PartnerPayoutDashboard = (props) => {
  const { width } = useWindowSize();

  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };
  return (
    <>
    {/* <div className="partner-payout-container" style={{ minWidth: "100%" }}>
      <section className="header-container" style={{ minWidth: "100%" }}>
       

        <Row>
                <Col md={6} className="btn-partner">
                  <Row className="d-flex align-items-center">
                    <Col calssName="AddLeadManin" md={4}>
                      <UiButton
                        title="Add Lead"
                        // type="submit"
                        onClick={goLead}
                        className="Addleadmain"
                      />
                    </Col>
                    <Col md={4} className="ButtonSet">
                      <GlobalLeadSearch
                        listingRefresh={partnerRefresh}
                        setListingRefresh={setPartnerRefresh}
                      />
                    </Col>
                    <Col md={3} className="btn-partner">
              <Button
                className="text-button"
                type="text"
                onClick={openLeadUploadStepper}
              >
                IMPORT LEADS
              </Button>
            </Col>
                  </Row>
                </Col>
              </Row>
      </section>
    </div> */}
    <div style={{maxWidth:"100%"}}>
       {width < 786 && (
        <Row>
          <Col lg={12} xs={12} md={12} sm={12}></Col>
        </Row>
      )}
          {width > 786 && (
        <Row>
          <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
            <Col md={8} className="search-bar"></Col>

            <Col md={4}>
              <div className="login-profie">
                <div className="img-sec">
                  <h2>
                    {adminFirstName(
                      props.userDetail?.firstName ??
                        props.userDetail?.userName?.split(" ")[0]?.trim()
                    )}
                  </h2>
                  <h2>
                    {adminLastName(
                      props.userDetail?.lastName ??
                        props.userDetail?.userName?.split(" ")[1]?.trim()
                    )}
                  </h2>
                </div>

                <div className="content-login">
                  <h4>{props.userDetail?.userName}</h4>
                  <h5>{props.userDetail?.roleName}</h5>
                  <div className="content-login-data">
                    <ChangePassword />
                    <div className="admin-small-space"> </div>
                    <Logout />
                    {/* <h6>Change Password | Logout</h6> */}
                  </div>
                </div>
              </div>
            </Col>
          </Col>
        </Row>
      )}
          <Row className="" style={{ marginTop:"10%", maxWidth: "100%" }}>
        <Col md={12} style={{ maxWidth: "100%", overflow: "hidden" }}>
          <PayoutDasboardComponent />
        </Col>
      </Row>
    </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    userDetail: state.auth?.userData,
  };
};

export default connect(mapStateToProps)(PartnerPayoutDashboard)
